export enum TrainingAppQueueHistoryType {
	SubscribedToQueue = 1,
	UnsubscribedFromQueueByUser = 2,
	UnsubscribedFromQueueByNewDocVersionPublication = 3,
	RestoredToQueueByUser = 4,
	AssignedToTrainingSession = 5,
	RemovedFromTrainingSession = 6
}